// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"2156de31","896":"b08d2fca"}[chunkId] + ".chunk.js";
};